export default __webpack_public_path__ + "static/media/WAS0380.34I-39715_-23591_0.184c1568.jpg";